export default __webpack_public_path__ + "static/media/skills_vector.1fb5f4a4.png";